<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="page_xi"></a>BAT BOMB</p>
<p class="noindent"><a id="page_xii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?aa11166e